module.exports = "/img/_/_/_/assets/images/creeper/battle/common//31.jpg?77c6f43addc086378dea1e3d0eae0a97";